// The trader's favourite coins (★), kept in this browser and shared by every
// component that shows them (the coin list, the pair header).
import { useSyncExternalStore } from "react";

const KEY = "vp.desk.favorites";
let current: string[] = read();
const listeners = new Set<() => void>();

function read(): string[] {
  try {
    const v: unknown = JSON.parse(localStorage.getItem(KEY) ?? "[]");
    return Array.isArray(v) ? v.filter((s): s is string => typeof s === "string" && /^[A-Z0-9]{2,20}USDT$/.test(s)) : [];
  } catch {
    return [];
  }
}

export const favorites = {
  get: () => current,
  has: (symbol: string) => current.includes(symbol),
  toggle(symbol: string): void {
    current = current.includes(symbol) ? current.filter(s => s !== symbol) : [...current, symbol];
    try {
      localStorage.setItem(KEY, JSON.stringify(current));
    } catch {
      /* storage blocked: keep them for this session */
    }
    for (const fn of listeners) fn();
  },
  subscribe(fn: () => void): () => void {
    listeners.add(fn);
    return () => listeners.delete(fn);
  },
  /** Tests only. */
  reload(): void {
    current = read();
  },
};

/** The favourite symbols (e.g. "SOLUSDT"), in the order they were added. */
export function useFavorites(): string[] {
  return useSyncExternalStore(favorites.subscribe, favorites.get);
}
